import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session, { game_type } from "../../Session";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction, LiveRoomData } from "../../lib/game_snacks/ILiveMultiplayer";
import { Signal } from "signals";
import PRNG from "../../lib/PRNG";
import PlayerSlot from "./PlayerSlot";
import Settings from "../Settings";
import TutorialPopup from "./TutorialPopup";
import Utils from "../../Utils";
import { game_event_type } from "../../service/MultiplayerEventManager";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class MathcMakingPopup extends Popup
{
    // #region Attributes //

    // private:

    private _gameStartedBg: PIXI.Sprite = null;
    private _innerLoadingCircle: PIXI.Sprite = null;
    private _outerLoadingCircle: PIXI.Sprite = null;
    private _versus: PIXI.Sprite = null;
    private _versusExplosion: PIXI.Sprite = null;
    private _headerText: PIXI.Text = null;
    private _footerText: PIXI.Text = null;
    private _arrPlayerSlot: Array<PlayerSlot> = null;
    private _settings: Settings = null;
    private _backBtn: Button = null;
    private _fadeOutBg: PIXI.Graphics = null;

    private _autoStartTimer: number = null;

    private _loadingCircleTimeline: gsap.core.Timeline = null;
    private _gameReadyTl: gsap.core.Timeline = null;

    private _isHost: boolean = null;
    private _isGameStarted: boolean = null;

    private _onGameStarted: Signal = null;

    // #endregion //


    public get onGameStarted(): Signal { return this._onGameStarted; } 


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        this._onGameStarted = new Signal();

        this._arrPlayerSlot = [];
        this._isHost = false;
        this._isGameStarted = false;

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_01.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );

        this._gameStartedBg = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_02.texture );
        this._gameStartedBg.visible = false;
        this._gameStartedBg.anchor.set( 0.5 );
        this._gameStartedBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._gameStartedBg );

        this._versusExplosion = new PIXI.Sprite( ServiceLocator.resources.vs_background_effect.texture );
        this._versusExplosion.visible = false;
        this._versusExplosion.anchor.set( 0.5 );
        this._versusExplosion.position.set( ServiceLocator.app.width * 0.5, 619 );
        this._root.addChild( this._versusExplosion );

        this._headerText = new PIXI.Text( "Play Online", { fontFamily: "jaro_regular", fontSize: 80, fill: 0xffffff, stroke: 0x000000, strokeThickness: 12, letterSpacing: 2 } );
        this._headerText.anchor.set( 0.5 );
        //this._headerText.position.set( ServiceLocator.app.width * 0.5, 158 );
        this._headerText.position.set( ServiceLocator.app.width * 0.5, 318 );
        this._root.addChild( this._headerText );

        /*let gameModeText: PIXI.Text = new PIXI.Text( "Selected game mode:", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        gameModeText.anchor.set( 0.5 );
        gameModeText.position.set( ServiceLocator.app.width * 0.5, 270 );
        this._root.addChild( gameModeText );

        let gameModeIcon: PIXI.Sprite = new PIXI.Sprite( Session.i.gameType == game_type.CLASSIC_MATCHMAKING ? ServiceLocator.resources.button_mode_classic.texture : ServiceLocator.resources.button_mode_301.texture );
        gameModeIcon.anchor.set( 0.5 );
        gameModeIcon.position.set( ServiceLocator.app.width * 0.5, 366 );
        this._root.addChild( gameModeIcon );*/

        const kArrPos: Array<PIXI.Point> = [ 
            new PIXI.Point( 158, 614 ),
            new PIXI.Point( ServiceLocator.app.width - 158, 614 ) ];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let playerSlot: PlayerSlot = new PlayerSlot( ServiceLocator.resources.matchmaking_avatar_base.texture );
            playerSlot.position.copyFrom( kArrPos[ i ] );
            this._root.addChild( playerSlot );            
            //
            this._arrPlayerSlot.push( playerSlot );
        }
        this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile );

        this._versus = new PIXI.Sprite( ServiceLocator.resources.vs.texture );
        this._versus.visible = false;
        this._versus.anchor.set( 0.5 );
        this._versus.position.set( ServiceLocator.app.width * 0.5 + 8, 605 );
        this._root.addChild( this._versus );

        this._backBtn = new Button( { on: "button_back", pressed: "button_back_pressed" } );
        this._backBtn.anchor.set( 0.5 );
        this._backBtn.position.set( 48, 44 + 16 );
        this._root.addChild( this._backBtn );
        this._backBtn.on( "pointertap", () => { 
            this._root.interactiveChildren = false;
            if ( window.GameSnacks )
            {
                window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                    .then( () => {
                        this._onClosed.dispatch( this ); 
                    } );
            }
            else
            {
                this._onClosed.dispatch( this ); 
            }
        } );

        this._footerText = new PIXI.Text( "Looking for opponent...", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        this._footerText.anchor.set( 0.5 );
        this._footerText.position.set( ServiceLocator.app.width * 0.5, 900 );
        this._root.addChild( this._footerText );

        this._innerLoadingCircle = new PIXI.Sprite( ServiceLocator.resources.loading_circle_int.texture );
        this._innerLoadingCircle.scale.set( 0.4 );
        this._innerLoadingCircle.anchor.set( 0.5 );
        this._innerLoadingCircle.position.copyFrom( this._arrPlayerSlot[ 1 ].position );
        this._innerLoadingCircle.y += this._arrPlayerSlot[ 1 ].height * 0.5 + 4;
        this._root.addChild( this._innerLoadingCircle );
        //
        this._outerLoadingCircle = new PIXI.Sprite( ServiceLocator.resources.loading_circle_ext.texture );
        this._outerLoadingCircle.scale.set( 0.4 );
        this._outerLoadingCircle.anchor.set( 0.5 );
        this._outerLoadingCircle.position.copyFrom( this._innerLoadingCircle.position );
        this._root.addChild( this._outerLoadingCircle );
        //
        this._loadingCircleTimeline = new gsap.core.Timeline();
        this._loadingCircleTimeline.to( this._innerLoadingCircle, { angle: -360, repeat: -1, duration: 6, ease: "linear.inOut" }, 0 );
        this._loadingCircleTimeline.to( this._outerLoadingCircle, { angle: 360, repeat: -1, duration: 6, ease: "linear.inOut" }, 0 );

        this._settings = new Settings();
        this._settings.init( true );
        this._settings.position.set( 592, 7 + 16 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );
        this._settings.onHome.addOnce( () => { 
            this._root.interactiveChildren = false;
            window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                .then( () => {
                    this._root.interactiveChildren = true;

                    this._onClosed.dispatch( this ); 
                } );
        } );

        this._fadeOutBg = new PIXI.Graphics();
        this._fadeOutBg.position.set( -ServiceLocator.app.safeAreaMarginX, -ServiceLocator.app.safeAreaMarginY );
        this._fadeOutBg.beginFill( 0x000000 );
        this._fadeOutBg.drawRect( 0, 0, ServiceLocator.app.safeAreaWidth, ServiceLocator.app.safeAreaHeight );
        this._fadeOutBg.endFill();
        this._root.addChild( this._fadeOutBg );
        this._fadeOutBg.visible = false,
        this._fadeOutBg.alpha = 0;

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.add( this._onMultiplayer_PlayerPresenceUpdated, this );
        ServiceLocator.multiplayerEventManager.onRoomLoaded.add( this._onRoom_Loaded, this );
        ServiceLocator.multiplayerEventManager.onEventsReceived.add( this._onMultiplayer_EventsReceived, this );
        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );

        window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.JOIN );

        Session.i.room = [];
    }

        private _onMultiplayer_PlayerPresenceUpdated( presenceEventPromise: Promise<LivePlayerDataEvent> ): void
        {
            console.log( "MatchMakingPopup.ts :: _onMultiplayer_PlayerPresenceUpdated() :: ini" );

            presenceEventPromise
                .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                    console.log( "MatchMakingPopup.ts :: _onMultiplayer_PlayerPresenceUpdated() :: promise processed :: data=" + JSON.stringify( livePlayerDataEvent, null, 4 ) );
                    this._autoStartTimer = 0;

                    if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                    {
                        let profile: Profile = livePlayerDataEvent.profile;
                        profile.uid = livePlayerDataEvent.uid;
                        Session.i.room.push( profile );

                        if ( livePlayerDataEvent.isLocalPlayer )
                        {
                            Session.i.profile.uid = profile.uid;
 
                            this._arrPlayerSlot[ 0 ].setPlayer( profile );

                            profile.dartSkinIndex = ServiceLocator.saved.data.selDartIndex;

                            this._updateOtherPlayerSlots();
                        }
                        else
                        {
                            this._updateOtherPlayerSlots();

                            this._innerLoadingCircle.visible = false;
                            this._outerLoadingCircle.visible = false;
                        }
                    }
                    else if ( livePlayerDataEvent.action == LivePresenceAction.LEAVE )
                    {
                        console.log( "MatchMakingPopup.ts :: _onMultiplayer_PlayerPresenceUpdated() :: LEAVE :: uid=" + livePlayerDataEvent.uid );
                        if ( Session.i.profile.uid != livePlayerDataEvent.uid ) 
                        {
                            for ( let i: number = 0; i < Session.i.room.length; ++i )
                            {
                                if ( Session.i.room[ i ].uid == livePlayerDataEvent.uid )
                                {
                                    if ( this._isGameStarted )
                                    {
                                        Session.i.room[ i ].dartSkinIndex = /*0;*/Math.floor( Math.random() * 10 ); // V2:
                                        Session.i.room[ i ].isBot = true;
                                    }
                                    else
                                    {
                                        Session.i.room.splice( i, 1 );
                                    }
                                    break;
                                }
                            }

                            if ( !this._isGameStarted )
                            {
                                this._updateOtherPlayerSlots();

                                this._innerLoadingCircle.visible = true;
                                this._outerLoadingCircle.visible = true;
                            }
                        }
                    }
                } )
                .catch( ( reason: any ) => {
                    console.log( "MatchMakingPopup.ts :: _onMultiplayer_PlayerPresenceUpdated() :: promise error caught = " + JSON.stringify( reason, null, 4 ) );
                } );

            console.log( "MatchMakingPopup.ts :: _onMultiplayer_PlayerPresenceUpdated() :: end" );
        }

            private _updateOtherPlayerSlots(): void
            {
                for ( let i: number = 1; i < Session.i.kGameRoomSize; ++i )
                {
                    this._arrPlayerSlot[ i ].empty();
                }

                let myProfileIndex: number = 0;
                while ( Session.i.room[ myProfileIndex ].uid != Session.i.profile.uid )
                {
                    myProfileIndex += 1;
                }

                let playerCount: number = 1;
                let playerProfileIndex: number = myProfileIndex + 1;
                if ( playerProfileIndex > Session.i.room.length - 1 )
                {
                    playerProfileIndex = 0;
                }
                let playerSlotIndex: number = 1;
                //
                while ( playerCount < Session.i.room.length )
                {
                    this._arrPlayerSlot[ playerSlotIndex ].setPlayer( Session.i.room[ playerProfileIndex ] );

                    playerProfileIndex += 1;
                    if ( playerProfileIndex > Session.i.room.length - 1 )
                    {
                        playerProfileIndex = 0;
                    }
                    playerSlotIndex += 1;

                    playerCount += 1;
                }
            }

        private _onRoom_Loaded( liveRoomData: Promise<LiveRoomData> ): void
        {
            console.log( "MatchMakingPopup.ts :: _onRoom_Loaded() :: ini" );
            liveRoomData
                .then( ( liveRoomData: LiveRoomData ) => {
                    console.log( "MatchMakingPopup.ts :: _onRoom_Loaded() :: promise processed :: data=" + JSON.stringify( liveRoomData, null, 4 ) );
                    this._isHost = liveRoomData.players.length == 1;

                    Session.i.room = [];
                    for ( let i: number = 0; i < liveRoomData.players.length; ++i )
                    {
                        if ( liveRoomData.players[ i ].action == LivePresenceAction.JOIN )
                        {
                            let profile: Profile = liveRoomData.players[ i ].profile;
                            profile.uid = liveRoomData.players[ i ].uid;
                            if ( Session.i.profile.uid == profile.uid )
                            {
                                profile.dartSkinIndex = ServiceLocator.saved.data.selDartIndex;
                            }
                            Session.i.room.push( profile );
                        }
                    }

                    if ( !this._isHost )
                    {
                        window.GameSnacks.liveMultiplayer.sendEvent( { payload: JSON.stringify( { dartSkinIndex: ServiceLocator.saved.data.selDartIndex } ) } );
                        
                        this._innerLoadingCircle.visible = false;
                        this._outerLoadingCircle.visible = false;
                    }

                    this._updateOtherPlayerSlots();
                } )
                .catch( ( reason: any ) => {
                    console.log( "MatchMakingPopup.ts :: _onRoom_Loaded() :: promise error caught = " + JSON.stringify( reason, null, 4 ) );
                } );
            console.log( "MatchMakingPopup.ts :: _onRoom_Loaded() :: end" );
        }

        private _onMultiplayer_EventsReceived( eventsPromise: Promise<LiveEventData[]> ): void
        {
            console.log( "MatchMakingPopup.ts :: _onMultiplayer_EventsReceived() :: ini" );
            eventsPromise
                .then( ( arrData: LiveEventData[] ) => {
                    while ( arrData.length > 0 )
                    {
                        let data: LiveEventData = arrData.shift();
                        console.log( "MatchMakingPopup.ts :: _onMultiplayer_EventsReceived() :: data=" + JSON.stringify( data, null, 4 ) );
                        if ( data.type === LiveEventDataType.START_GAME
                            && !this._isGameStarted )
                        {
                            console.log( "MatchMakingPopup.ts :: _onMultiplayer_EventsReceived() :: START_GAME" );

                            let kStartGamePayload: IStartGamePayload = JSON.parse( data.payload );
                            Session.i.prng = new PRNG( kStartGamePayload.seed );
                            //
                            Session.i.room = kStartGamePayload.room;

                            this._isGameStarted = true;

                            if ( this._loadingCircleTimeline )
                            {
                                this._loadingCircleTimeline.kill();
                                this._loadingCircleTimeline = null;
                            }
                            this._innerLoadingCircle.visible = false;
                            this._outerLoadingCircle.visible = false;
                            //
                            this._backBtn.interactive = false;
                            gsap.to( this._backBtn, { alpha: 0, duration: 0.4, ease: "linear.inOut" } );
                            //
                            this._settings.interactive = false;
                            gsap.to( this._settings, { alpha: 0, duration: 0.4, ease: "linear.inOut" } );

                            for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
                            {
                                if ( Session.i.room[ i ].isBot )
                                {
                                    this._arrPlayerSlot[ i ].setPlayer( Session.i.room[ i ] );
                                }
                            }

                            let opponentProfile: Profile = null;
                            for ( let profile of Session.i.room )
                            {
                                if ( profile.uid != Session.i.profile.uid )
                                {
                                    opponentProfile = profile;
                                    break;
                                }
                            }
                            this._footerText.text = opponentProfile.username.prefix + " just joined!  Let's Play!"

                            this._gameStartedBg.visible = true;
                            this._gameStartedBg.alpha = 0;
                            //
                            this._versusExplosion.visible = true;
                            this._versusExplosion.scale.set( 1, 0 );
                            //
                            this._versus.visible = true;
                            this._versus.scale.set( 0 );
                            //
                            this._gameReadyTl = new gsap.core.Timeline();
                            this._gameReadyTl.to( this._gameStartedBg, { alpha: 1, duration: 1.6, ease: "sine.out" }, 0 );
                            this._gameReadyTl.to( this._versusExplosion.scale, { y: 1, duration: 0.8, ease: "expo.out" }, 0 );
                            this._gameReadyTl.to( this._versus.scale, { x: 1, y: 1, duration: 1, ease: "back.out" }, 0 );
                            this._gameReadyTl.to( this._fadeOutBg, { alpha: 1, duration: 0.4, ease: "linear.inOut" }, ">+2" );
                            this._gameReadyTl.call( () => { this._fadeOutBg.visible = true; }, null, "<" );
                            this._gameReadyTl.call( () => { this._onGameStarted.dispatch( this ); }, null );
                        
                            ServiceLocator.audio.playSfx( "matchmaking_found" );
                            ServiceLocator.audio.stopMusic();
                        }
                        else if ( data.payload !== undefined && !this._isGameStarted )
                        {
                            if ( this._isHost )
                            {
                                const kPlayerDetails: IPlayerDetails = JSON.parse( data.payload );
                                Session.i.room[ 1 ].dartSkinIndex = kPlayerDetails.dartSkinIndex;
                            
                                this._autoStartTimer = 11;
                            }
                        }
                        else
                        {
                            Session.i.gameEvents.push( data );
                        }
                    }
                } )
                .catch( ( reason: any ) => {
                    console.log( "MatchMakingPopup.ts :: _onMultiplayer_EventsReceived() :: promise error caught = " + JSON.stringify( reason, null, 4 ) );
                } );
            console.log( "MatchMakingPopup.ts :: _onMultiplayer_EventsReceived() :: end" );
        }

            private _fillRoomWithBots(): void
            {                
                const kArrBotName: Array<string> = Utils.generateBotNames( 1 );
                const kBotAvatarIndex: number = Math.floor( Math.random() * 12 );
                let profile: Profile = { 
                    username: { prefix: kArrBotName[ 0 ], suffix: "" },
                    avatar: { src: "avatar_" + kBotAvatarIndex.toString(), alt: null } };
                profile.isBot = true;
                profile.dartSkinIndex = /*0;*/Math.floor( Math.random() * 10 ); // V2:
                Session.i.room.push( profile );
            }

        private _onProfile_Changed( profile: Profile): void
        {
            ( Session.i.profile.avatar as any ) = profile.avatar;
            ( Session.i.profile.username as any ) = profile.username;

            this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile )
        }

    public onLeave(): void
    {
        this._onGameStarted.dispose();
        this._onGameStarted = null;

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
        ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
        ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        if ( this._loadingCircleTimeline )
        {
            this._loadingCircleTimeline.kill();
            this._loadingCircleTimeline = null;
        }

        if ( this._gameReadyTl )
        {
            this._gameReadyTl.kill();
            this._gameReadyTl = null;
        }

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        if ( this._isGameStarted ) { return; }

        if ( this._isHost
            && Session.i.room.length <= Session.i.kGameRoomSize )
        {
            this._autoStartTimer += dt;
            if ( this._autoStartTimer > 10 ) 
            //if ( this._autoStartTimer > 1 ) // TEST: 
            {
                if ( Session.i.room.length == 1 )
                {
                    this._fillRoomWithBots();
                }

                const kSeed: number = Math.floor( Math.random() * 9999 );
                let arrProfile: Array<Profile> = [];
                for ( let profile of Session.i.room )
                {
                    arrProfile.push( profile );
                }
                //
                //ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
                //
                console.log( "MatchMakingPopup.ts :: onUpdate() :: START GAME" );
                window.GameSnacks.liveMultiplayer.sendEvent( { 
                    type: LiveEventDataType.START_GAME,
                    payload: JSON.stringify( { seed: kSeed, room: arrProfile } )
                } );

                //Session.i.prng = new PRNG( kSeed );

                //this._onGameStarted.dispatch( this, game_type.MATCHMAKING );
            }
        }
    }

    // #endregion //
}

export interface IStartGamePayload
{
    seed: number,
    room: Array<Profile>
}

export interface IPlayerDetails
{
    dartSkinIndex: number;
}